/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ServeChatAttachmentSecurity = {
  apikeyHeaderGramKey?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
  chatSessionsTokenHeaderGramChatSession?: string | undefined;
};

export type ServeChatAttachmentRequest = {
  /**
   * The ID of the attachment to serve
   */
  id: string;
  /**
   * The project ID that the attachment belongs to
   */
  projectId: string;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * Chat Sessions token header
   */
  gramChatSession?: string | undefined;
};

export type ServeChatAttachmentResponse = {
  headers: { [k: string]: Array<string> };
  result: ReadableStream<Uint8Array>;
};

/** @internal */
export type ServeChatAttachmentSecurity$Outbound = {
  "apikey_header_Gram-Key"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
  "chat_sessions_token_header_Gram-Chat-Session"?: string | undefined;
};

/** @internal */
export const ServeChatAttachmentSecurity$outboundSchema: z.ZodMiniType<
  ServeChatAttachmentSecurity$Outbound,
  ServeChatAttachmentSecurity
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
    chatSessionsTokenHeaderGramChatSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      sessionHeaderGramSession: "session_header_Gram-Session",
      chatSessionsTokenHeaderGramChatSession:
        "chat_sessions_token_header_Gram-Chat-Session",
    });
  }),
);

export function serveChatAttachmentSecurityToJSON(
  serveChatAttachmentSecurity: ServeChatAttachmentSecurity,
): string {
  return JSON.stringify(
    ServeChatAttachmentSecurity$outboundSchema.parse(
      serveChatAttachmentSecurity,
    ),
  );
}

/** @internal */
export type ServeChatAttachmentRequest$Outbound = {
  id: string;
  project_id: string;
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Chat-Session"?: string | undefined;
};

/** @internal */
export const ServeChatAttachmentRequest$outboundSchema: z.ZodMiniType<
  ServeChatAttachmentRequest$Outbound,
  ServeChatAttachmentRequest
> = z.pipe(
  z.object({
    id: z.string(),
    projectId: z.string(),
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramChatSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectId: "project_id",
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramChatSession: "Gram-Chat-Session",
    });
  }),
);

export function serveChatAttachmentRequestToJSON(
  serveChatAttachmentRequest: ServeChatAttachmentRequest,
): string {
  return JSON.stringify(
    ServeChatAttachmentRequest$outboundSchema.parse(serveChatAttachmentRequest),
  );
}

/** @internal */
export const ServeChatAttachmentResponse$inboundSchema: z.ZodMiniType<
  ServeChatAttachmentResponse,
  unknown
> = z.pipe(
  z.object({
    Headers: z._default(z.record(z.string(), z.array(z.string())), {}),
    Result: z.custom<ReadableStream<Uint8Array>>(x =>
      x instanceof ReadableStream
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      "Headers": "headers",
      "Result": "result",
    });
  }),
);

export function serveChatAttachmentResponseFromJSON(
  jsonString: string,
): SafeParseResult<ServeChatAttachmentResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ServeChatAttachmentResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ServeChatAttachmentResponse' from JSON`,
  );
}
